import { FormField } from '@domain-group/suit-theme'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

import Task from './Task'

interface TasksProps {
  orderItemPayload: UseOrderItemPayload,
}

const Tasks = (props: TasksProps) => {
  const {
    orderItemPayload: {
      filteredOrderItemTasks,
    },
  } = props

  return (
    <FormField label="Tasks" marginTop="large">
      {filteredOrderItemTasks.map(orderItemTask => (
        <Task key={orderItemTask.id} orderItemTask={orderItemTask} />
      ))}
    </FormField>
  )
}

export default Tasks
